export default [
    'pch_provider',
    'pch_provider.pch_provider_account',
    'pch_provider_branch_offices',
    'pch_provider_branch_offices.g_commune',
    'pch_payment_condition',
    'pch_purchase_invoice',
    'pch_purchase_credit_note',
    'pch_purchase_debit_note',
    'pch_purchase_credit_note_canceled_by',
    'pch_purchase_debit_note_canceled_by',
    'pch_provider_debt_to_pay',
]
